// extracted by mini-css-extract-plugin
export var brand = "_bl-9";
export var compact = "_bl-6";
export var extraSmall = "_bl-7";
export var icon = "_bl-0";
export var large = "_bl-4";
export var light = "_bl-1";
export var medium = "_bl-5";
export var outline = "_bl-b";
export var primaryDark = "_bl-a";
export var primaryLight = "_bl-8";
export var primaryModern = "_bl-c";
export var success = "_bl-2";
export var successSolid = "_bl-3";